export default "__VITE_ASSET__CAb7TEMX__"